import { Chip } from '@mui/material'
import { createMRTColumnHelper, MRT_ColumnDef } from 'material-react-table'
import { useMemo } from 'react'

import { TextCell } from '@/components'
import { createHeaderWithTooltip } from '@/components/MrtTable/helpers'
import { useAppContext } from '@/hooks'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { ValidationMessageDto } from '@/rtkApi/mddApiSliceGenerated'

import { getColor } from '../helpers'

export const useValidationColumns = () => {
	const { t } = useAppContext()

	const {
		state: { editMode },
	} = useDetailTabContext()

	const columnHelper = createMRTColumnHelper<ValidationMessageDto>()

	const columns = useMemo(
		() => [
			columnHelper.accessor('id', {
				...createHeaderWithTooltip(t('VALIDATION_ID')),
				size: 50,
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('severity', {
				...createHeaderWithTooltip(t('VALIDATION_SEVERITY')),
				Cell: ({ cell }) => {
					const cellValue = cell.getValue() || ''
					const color = getColor(cellValue)

					return (
						<div className="py-1 px-2">
							<Chip label={cellValue} color={color} size="small" />
						</div>
					)
				},
			}),
			columnHelper.accessor('nodeName', {
				...createHeaderWithTooltip(t('VALIDATION_ELEMENT')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						customValue={`${row.original.nodeName} (${row.original.nodeType})`}
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('elementName', {
				...createHeaderWithTooltip(t('VALIDATION_ATTRIBUTE')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						customValue={`${row.original.elementName} (${row.original.elementType})`}
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('message', {
				...createHeaderWithTooltip(t('VALIDATION_MESSAGE')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('description', {
				...createHeaderWithTooltip(t('VALIDATION_DESCRIPTION')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
		],
		[columnHelper, editMode, t],
	)

	return columns as MRT_ColumnDef<ValidationMessageDto>[]
}
